var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4149 0.915043C10.1493 1.18071 10.0001 1.54098 10.0001 1.91663C10.0001 2.29228 10.1493 2.65255 10.4149 2.91822L15.08 7.58329H1.49984C1.12411 7.58329 0.763775 7.73255 0.498096 7.99823C0.232418 8.26391 0.0831608 8.62425 0.0831608 8.99997C0.0831608 9.3757 0.232418 9.73603 0.498096 10.0017C0.763775 10.2674 1.12411 10.4166 1.49984 10.4166H15.08L10.4149 15.0817C10.1571 15.349 10.0145 15.7067 10.0179 16.078C10.0212 16.4493 10.1702 16.8045 10.4327 17.067C10.6953 17.3296 11.0505 17.4786 11.4218 17.4819C11.7931 17.4852 12.1508 17.3427 12.4181 17.0849L19.5014 10.0016L19.5043 9.99875C19.6354 9.8676 19.7395 9.71189 19.8105 9.54053C19.8814 9.36916 19.918 9.18549 19.918 9C19.918 8.81452 19.8814 8.63085 19.8105 8.45948C19.7395 8.28812 19.6354 8.13241 19.5043 8.00125L19.5014 7.99843L12.4181 0.91501C12.1524 0.649435 11.7922 0.500244 11.4165 0.500244C11.0409 0.500244 10.6806 0.649435 10.4149 0.91501L10.4149 0.915043Z",
    fill: "url(#paint0_linear_270_1182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_270_1182",
    x1: 19.918,
    y1: 0.500244,
    x2: -2.1966,
    y2: 3.54045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d54d8cde690ada2d06139c595024ffb0.svg";
export { ForwardRef as ReactComponent };